import { render, staticRenderFns } from "./dataChartPreview.vue?vue&type=template&id=70bcd94e&scoped=true&"
import script from "./dataChartPreview.vue?vue&type=script&lang=js&"
export * from "./dataChartPreview.vue?vue&type=script&lang=js&"
import style0 from "./dataChartPreview.vue?vue&type=style&index=0&id=70bcd94e&scoped=true&lang=less&"
import style1 from "./dataChartPreview.vue?vue&type=style&index=1&id=70bcd94e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcd94e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bcd94e')) {
      api.createRecord('70bcd94e', component.options)
    } else {
      api.reload('70bcd94e', component.options)
    }
    module.hot.accept("./dataChartPreview.vue?vue&type=template&id=70bcd94e&scoped=true&", function () {
      api.rerender('70bcd94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/preview/dataChartPreview.vue"
export default component.exports